export default {
  animation: 200,
  forceFallback: true,
  fallbackClass: 'is-dragging',
  fallbackOnBody: true,
  ghostClass: 'is-ghost',
  fallbackTolerance: 1,
};
